import React from "react";
import { Helmet } from "react-helmet";
import Logo from "../static/img/logo.jpeg";

const SITE_URL = "https://koderbox.com";

const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "EducationalOrganization",
  name: "Koderbox",
  url: SITE_URL,
  logo: `${SITE_URL}/favicon/favicon-32x32.png`,
  description:
    "Koderbox offers live online foreign language courses (Japanese, German, French, Spanish, Korean, Chinese) and coding/programming courses, plus custom software development services.",
  sameAs: [
    "https://www.facebook.com/koderbox",
    "https://www.instagram.com/koderbox/",
  ],
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+91-9990484089",
    contactType: "customer service",
    email: "admin@koderbox.com",
  },
};

const MetaTags = ({ title, description, path, schema }) => {
  const canonicalUrl =
    SITE_URL +
    (path || (typeof window !== "undefined" ? window.location.pathname : "/"));

  const schemaList = [ORGANIZATION_SCHEMA, ...(schema ? [].concat(schema) : [])];

  return (
    <Helmet>
      {/* Page title */}
      <title>{title}</title>

      {/* Basic Meta */}
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {/* ✅ FAVICON (THIS WAS MISSING) */}
      <link rel="icon" href="/favicon/favicon.ico" />
      <link rel="shortcut icon" href="/favicon/favicon.ico" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon/favicon-16x16.png" />
      <link rel="apple-touch-icon" href="/favicon/apple-touch-icon.png" />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta
        property="og:description"
        content={description?.substring(0, 200)}
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={Logo} />
      <meta property="og:image:alt" content="Koderbox" />
      <meta property="og:site_name" content="Koderbox" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@koderbox" />
      <meta name="twitter:creator" content="@koderbox" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={Logo} />
      <meta name="twitter:image:alt" content="Koderbox" />

      {/* Structured data */}
      {schemaList.map((item, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
};

export default MetaTags;
